import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSimpleAuth } from '../../context/SimpleAuthContext';
import './SimpleAdminPage.css';

const SimpleAdminPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useSimpleAuth();

  const handleLogout = () => {
    logout();
    navigate('/simple-login');
  };

  if (!user || user.role !== 'admin') {
    return <div>Access denied. Admin privileges required.</div>;
  }

  // Mock data for demo
  const mockStats = {
    totalUsers: 1247,
    activeUsers: 1189,
    newUsers: 89,
    totalChats: 15678
  };

  const mockUsers = [
    { id: 1, name: 'John Doe', email: 'john@example.com', status: 'active' },
    { id: 2, name: 'Jane Smith', email: 'jane@example.com', status: 'active' },
    { id: 3, name: 'Bob Johnson', email: 'bob@example.com', status: 'inactive' }
  ];

  return (
    <div className="simple-admin-container">
      <nav className="simple-nav">
        <h2>Simple Admin Dashboard</h2>
        <div className="nav-right">
          <span>Admin: {user.name}</span>
          <button onClick={handleLogout} className="logout-btn">
            Logout
          </button>
        </div>
      </nav>

      <main className="simple-main">
        <div className="welcome-card">
          <h1>Admin Dashboard</h1>
          <p>Simple admin interface for demos. No complex backend needed.</p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <h3>Total Users</h3>
            <div className="stat-number">{mockStats.totalUsers}</div>
            <div className="stat-change">+12% this month</div>
          </div>
          <div className="stat-card">
            <h3>Active Users</h3>
            <div className="stat-number">{mockStats.activeUsers}</div>
            <div className="stat-change">+8% this month</div>
          </div>
          <div className="stat-card">
            <h3>New Users</h3>
            <div className="stat-number">{mockStats.newUsers}</div>
            <div className="stat-change">+23% this month</div>
          </div>
          <div className="stat-card">
            <h3>Total Chats</h3>
            <div className="stat-number">{mockStats.totalChats}</div>
            <div className="stat-change">+15% this month</div>
          </div>
        </div>

        <div className="users-card">
          <div className="users-header">
            <h3>User Management</h3>
            <button 
              onClick={() => navigate('/simple-userlist')}
              className="view-all-btn"
            >
              View Full User List
            </button>
          </div>
          <div className="users-table">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {mockUsers.map(user => (
                  <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>
                      <span className={`status-badge ${user.status}`}>
                        {user.status}
                      </span>
                    </td>
                    <td>
                      <button className="action-btn edit">Edit</button>
                      <button className="action-btn delete">Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="actions-card">
          <h3>Quick Actions</h3>
          <div className="action-buttons">
            <button className="action-btn primary">Add New User</button>
            <button className="action-btn secondary">Generate Report</button>
            <button className="action-btn secondary">System Settings</button>
            <button className="action-btn warning">Backup Database</button>
          </div>
        </div>

        <div className="demo-note">
          <h4>Demo Information</h4>
          <p>This is a simplified admin demo. In a real application, you would have:</p>
          <ul>
            <li>Real user data from database</li>
            <li>Advanced analytics and charts</li>
            <li>User management operations</li>
            <li>System configuration</li>
            <li>Audit logs and security</li>
          </ul>
        </div>
      </main>
    </div>
  );
};

export default SimpleAdminPage;
